import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewMapsRoutingModule } from './new-maps-routing.module';
import { NewMapsComponent } from './new-maps.component';
import { AgmCoreModule } from '@agm/core';
import { NewMapsDialogViewComponent } from './new-maps-dialog-view/new-maps-dialog-view.component';
import { NewMapsDialogComponent } from './new-maps-dialog/new-maps-dialog.component';
import { MyCustomMaterialModule } from 'san-common';


@NgModule({
  declarations: [
    NewMapsComponent,
    NewMapsDialogViewComponent,
    NewMapsDialogComponent
  ],
  imports: [
    CommonModule,
    NewMapsRoutingModule,
    AgmCoreModule,
    MyCustomMaterialModule
  ],
  exports: [
    NewMapsComponent,
    NewMapsDialogViewComponent,
    NewMapsDialogComponent],
  entryComponents: [NewMapsDialogViewComponent]
})
export class NewMapsModule { }
